var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#576EDB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1019 16.0658C23.0989 17.3608 22.7122 18.6259 21.9906 19.7012C21.269 20.7766 20.2449 21.6139 19.0476 22.1075C17.8503 22.601 16.5336 22.7286 15.2638 22.4742C13.9941 22.2198 12.8282 21.5947 11.9135 20.6779C10.9988 19.7612 10.3764 18.5939 10.1248 17.3235C9.87323 16.0532 10.0038 14.7368 10.5001 13.5406C10.9963 12.3444 11.836 11.3222 12.913 10.603C13.9899 9.88384 15.2559 9.5 16.5509 9.5C17.4125 9.5 18.2655 9.66994 19.0613 10.0001C19.8571 10.3302 20.5799 10.8141 21.1884 11.424C21.7969 12.0339 22.2791 12.7578 22.6075 13.5543C22.9358 14.3508 23.1038 15.2042 23.1019 16.0658Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7046 21.2217L25.1238 24.6409",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.431827201aaba8fa10b77e77240b38fb.svg";
export { ForwardRef as ReactComponent };